import { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import RegisterPage from './pages/RegisterPage'
import ScoringPage from './pages/ScoringPage'
import AdminPage from './pages/AdminPage'
import PhaseTwoPage from './pages/PhaseTwoPage'
import { useAuthStore } from './store/authStore'
import { authAPI } from './services/api'

function App() {
  const { token, isAuthenticated, user, setUser, logout } = useAuthStore()
  const [isBootstrapping, setIsBootstrapping] = useState(Boolean(token && !user))

  useEffect(() => {
    document.title = '\u4e2a\u6027\u5316\u56fe\u50cf\u6807\u6ce8\u5e73\u53f0'
  }, [])

  useEffect(() => {
    const bootstrapUser = async () => {
      if (!token || user) {
        setIsBootstrapping(false)
        return
      }

      setIsBootstrapping(true)

      try {
        const currentUser = await authAPI.getCurrentUser()
        setUser(currentUser)
      } catch (error) {
        console.error('�ָ���¼״̬ʧ��:', error)
        logout()
      } finally {
        setIsBootstrapping(false)
      }
    }

    bootstrapUser()
  }, [token, user, setUser, logout])

  if (isBootstrapping) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
        <p className="text-lg text-gray-600">���ڻָ��û��Ự...</p>
      </div>
    )
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={
            !isAuthenticated ? <Navigate to="/login" /> :
            <ScoringPage />
          } />
          <Route path="login" element={
            isAuthenticated ? <Navigate to="/scoring" /> : <LoginPage />
          } />
          <Route path="register" element={
            isAuthenticated ? <Navigate to="/scoring" /> : <RegisterPage />
          } />
          <Route path="scoring" element={
            isAuthenticated ? <ScoringPage /> : <Navigate to="/login" />
          } />
          <Route path="completion" element={
            isAuthenticated ? <Navigate to="/scoring" replace /> : <Navigate to="/login" />
          } />
          <Route path="phase2" element={
            isAuthenticated ? <PhaseTwoPage /> : <Navigate to="/login" />
          } />
          <Route path="phase2/rescore" element={
            isAuthenticated ? <PhaseTwoPage /> : <Navigate to="/login" />
          } />
          <Route path="phase2/completion" element={
            isAuthenticated ? <Navigate to="/phase2/rescore" replace /> : <Navigate to="/login" />
          } />
          <Route path="admin" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </Router>
  )
}

export default App
